// Import React
import React from "react";

// Footer component
function Footer() {
  return (
    // Footer container with Bootstrap classes
    <footer className="bg-dark text-white p-3 mt-auto">
      <div className="container text-center">
        {/* Footer text */}
        <p className="mb-1">
           Quiz App. All rights reserved.
        </p>

      
        
      </div>
    </footer>
  );
}

// Export Footer component
export default Footer;
